import {
  GET_CLAIMS,
  GET_CLAIMS_ERROR,
  GET_CLAIMS_SUCCESS,
  SAVE_CLAIMS,
  SAVE_CLAIMS_SUCCESS,
  SAVE_CLAIMS_ERROR,
} from "../../constants/action-types";

export const claimedCEInitialState = {
  isClaimsSaving: false,
  isClaimsLoading: false,
  claimsByYears: [],
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_CLAIMS: {
      return {
        ...state,
        isClaimsLoading: true,
      };
    }

    case GET_CLAIMS_SUCCESS: {
      return {
        ...state,
        claimsByYears: payload,
        isClaimsLoading: false,
      };
    }

    case GET_CLAIMS_ERROR: {
      return {
        ...state,
        claimsByYears: [],
        isClaimsLoading: false,
      };
    }

    case SAVE_CLAIMS: {
      return {
        ...state,
        isClaimsSaving: true,
      };
    }

    case SAVE_CLAIMS_SUCCESS:
    case SAVE_CLAIMS_ERROR: {
      return {
        ...state,
        isClaimsSaving: false,
      };
    }

    default:
      return state;
  }
};
